const data = {
	"width": 48,
	"height": 48,
	"body": "<path fill=\"#2196F3\" d=\"M17.1 5L14 8.1L29.9 24L14 39.9l3.1 3.1L36 24z\"/>"
};
export default data;
